/*
*  geolocation-simulator.js v0.0.1
*  (c) 2014, Russell Goldenberg
*  MIT License
*/

(function($) {
    function get_random_accuracy() {
        return (Math.random()*80)+1;
    }
    //constants
    var KM_IN_DEGREE = 110.562,
        SECONDS_IN_HOUR = 3600,
        UPDATE_INTERVAL = 1000;
    
    $.GeoSim = function(params) {
        var self = {};
        //private vars
        var _watchTimer = null,
            // _coords = params.coords,
            _speed = (params.speed || 40) / SECONDS_IN_HOUR, // km/second (defaults to 40kmh or 25mph)
            _current = { 
                coords: { 
                    latitude: 0,
                    longitude: 0,
                    accuracy: get_random_accuracy(),
                    altitude: null,
                    altitudeAccuracy: null,
                    heading: null,
                    speed: null
                },
                timestamp: 1},
            _rate = {latitude: 0, longitude: 0},
            _index = -1,
            _pauseTimeout,
            _numSteps,
            _currentStep,
            _tracker = params.tracker,
            _repeat = params.repeat || false;
            
        var _onsimulationfinished = params.onsimulationfinished || function() {};
        var _show_route = false;
        var _addGPSRouteCallback = function(evt) { 
            self.updateViewportHandler.call(self, evt);
        };

        self.updateViewportHandler = function(evt) {
            for(var i = 1; i < _tracker.gps_simulator._current_coordinates.length; i++) {
                var prev = _tracker.gps_simulator._current_coordinates[i-1];
                var current = _tracker.gps_simulator._current_coordinates[i];
                var prev_pt_xy = _tracker.location_provider.lonlat2vp(prev.longitude, prev.latitude);
                var current_pt_xy = _tracker.location_provider.lonlat2vp(current.longitude, current.latitude);

                var prev_pt = new OpenSeadragon.Point(prev_pt_xy[0], prev_pt_xy[1]);
                var current_pt = new OpenSeadragon.Point(current_pt_xy[0], current_pt_xy[1]);

                var prev_pt_canvas    = _tracker.viewers[0].viewport.pixelFromPoint(prev_pt);
                var current_pt_canvas = _tracker.viewers[0].viewport.pixelFromPoint(current_pt);
                var ctx = _tracker.viewers[0].drawer.context;
                // draw line
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.shadowBlur = 6;
                ctx.shadowOffsetX = 6;
                ctx.shadowOffsetY = 6;
                ctx.moveTo(prev_pt_canvas.x, prev_pt_canvas.y);
                ctx.lineTo(current_pt_canvas.x, current_pt_canvas.y);
                ctx.stroke();
            }
        };

        self.showGPSRoute = function() {
            if (typeof(_tracker) !== 'undefined') {
                _tracker.viewers[0].addHandler('update-viewport', _addGPSRouteCallback);
            }
            _tracker.viewers[0].world.draw();
            _tracker.viewers[0].raiseEvent('update-viewport', _tracker.viewers[0]);
            _show_route = true;
        };

        self.hideGPSRoute = function() {
            if (typeof(_tracker) !== 'undefined') {
                _tracker.viewers[0].removeHandler('update-viewport', _addGPSRouteCallback);
            }
            _tracker.viewers[0].world.draw();
            _tracker.viewers[0].raiseEvent('update-viewport', _tracker.viewers[0]);
            _show_route = false;
        };
        
        self.toggleGPSRoute = function() {
            if (_show_route) {
                self.hideGPSRoute();
            }
            else {
                self.showGPSRoute();
            }
        };


        //public functions            
        self.start = function() {
            // do nothing if no simulation data is given
            if (_tracker.gps_simulator._current_coordinates.length == 0) {
                console.error("No GPS simulation data");
            }
            else {
                nextCoord();
            }
            
        };

        self.restore = function() {
            if (_tracker.gps_simulator._current_coordinates.length > 0) {
                clearTimeout(_currentTimer);
                navigator.geolocation.clearWatch(_watchTimer);
                self.hideGPSRoute();
    
                navigator.geolocation.getCurrentPosition = _getCurrentPosition;
                navigator.geolocation.watchPosition = _watchPosition;
                navigator.geolocation.clearWatch = _clearWatch;
            }
            else {
                console.error("No GPS data was present at the time of calling restore()");
            }
        };
 
        //private functions

        //advance to next coordinate in array
        function nextCoord() { 
            _index++;
            //check if route completed
            if(_index < _tracker.gps_simulator._current_coordinates.length - 1) {
                var coord = _tracker.gps_simulator._current_coordinates[_index];
                
                //set current coordinate, to make sure it makes the jump
                _current.coords.latitude = coord.latitude;
                _current.coords.longitude = coord.longitude;
                _current.coords.accuracy = get_random_accuracy();
                //set rate of change
                //distance between points with direction for lat and lon (km)
                var deltaLat = (_tracker.gps_simulator._current_coordinates[_index+1].latitude - coord.latitude) * KM_IN_DEGREE,
                    deltaLon = (_tracker.gps_simulator._current_coordinates[_index+1].longitude - coord.longitude) * KM_IN_DEGREE;
                
                //as the crow flies distance (km)
                var deltaDist = Math.sqrt((deltaLat * deltaLat) + (deltaLon * deltaLon));
                
                //total time between points at desired speed (sec)
                var deltaSeconds = Math.floor(deltaDist / _speed);

                //rate of change for each update (1 sec) in lat/lon
                _rate.latitude = deltaLat / deltaSeconds / KM_IN_DEGREE;
                _rate.longitude = deltaLon / deltaSeconds / KM_IN_DEGREE;

                //total steps aka number of seconds
                _numSteps = deltaSeconds;
                _currentStep = 0;

                //check for pause request
                if(coord.pause) {
                    console.log('(pausing for ', Math.floor(coord.pause / 1000) , 'seconds)');
                    _pauseTimeout = setTimeout(step, coord.pause);
                } else {
                    //proceed at regular interval
                    _currentTimer = setTimeout(step, UPDATE_INTERVAL);
                }
            } else { 
                //path is complete
                if (!_repeat) {
                    alert('到着しました');
                    self.restore(); 
                    _onsimulationfinished();
                }
                else {
                    _index = -1;
                    _currentStep = 0;
                    nextCoord();
                }   
            }
        }

        //advance to next update along path between points
        function step() {
            _currentStep++;
            if(_currentStep < _numSteps) {
                _current.coords.latitude += _rate.latitude;
                _current.coords.longitude += _rate.longitude;
                _current.coords.accuracy = get_random_accuracy();
                setTimeout(step, UPDATE_INTERVAL);
            } else {
                nextCoord();
            }
        }

        //override native geolocation
        var _getCurrentPosition = navigator.geolocation.getCurrentPosition;
        navigator.geolocation.getCurrentPosition = function(cb, error, options) {
            cb(_current);
        };

        var _watchPosition = navigator.geolocation.watchPosition;
        navigator.geolocation.watchPosition = function(cb, error, options) { 
            var sendPos = function() {
                cb(_current); 
            };

            sendPos();
            _watchTimer = setInterval(sendPos, 1000);
            return _watchTimer;
        };

        var _clearWatch = navigator.geolocation.clearWatch;
        navigator.geolocation.clearWatch = function() {
            clearTimeout(_watchTimer);
        };

        return self;
    };

    // window.GeolocationSimulator = GeoSim;
})(ABDOMap);